module.exports = __webpack_public_path__ + "img/iran-flag.1ff3909c.svg";